export const DEFAULT_URL = 'https://www.google.com/maps/embed/v1/place?';
export const MAP_HEIGHT = 350;
export const MAP_WIDTH = '100%';
export const MAP_ZOOM = 16;
export const MAP_TITLE = 'Location map';
export const MIN_ZOOM = 10;
export const MAX_ZOOM = 18;
export const FALLBACK_MAP_CENTER = { lat: 31, lng: -97 };
export const MAP_FALLBACK_ZOOM = 4;
